import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

import { useAuthUser } from '@/modules/Auth'

export const useTopMe = () => {
  const client = useGyymClient()
  const { isVerified } = useAuthUser()
  const { data } = useGyymSWR(isVerified ? client.user.top.me : null)
  return data?.data
}
